"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import PocCloudTabs from "@/components/pageTabs/pocCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import WhyOneMind from "./components/whyOnemInd";
import WhyChooseComponent from "./components/whyChoose";

const LabAsAServicePage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout>
        <PocCloudTabs />
        <Intro />
        <FeaturesComponent />
      </PageLayout>
      <WhyOneMind />
      <PageLayout showContactForm>
        <WhyChooseComponent />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default LabAsAServicePage;
